import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LandingPage from './pages/LandingPage';
import MenuPage from './pages/MenuPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import KasaPanel from './KasaPanel';
import GarsonPanel from './GarsonPanel';
import MutfakPanel from './MutfakPanel';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/garson" element={<PrivateRoute allowedRoles={['Garson']}><GarsonPanel /></PrivateRoute>} />
          <Route path="/kasa" element={<PrivateRoute allowedRoles={['Kasa', 'Admin']}><KasaPanel /></PrivateRoute>} />
          <Route path="/mutfak" element={<PrivateRoute allowedRoles={['Mutfak', 'Admin']}><MutfakPanel /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute allowedRoles={['Admin']}><AdminDashboard /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

